


/* aux data types */
export interface Box {
    x: number, y: number, w: number, h: number
}

export interface Point {
    x: number, y: number
}

export function domRectToBox(rect: DOMRect): Box {
    return { x: rect.x, y: rect.y, w: rect.width, h: rect.height }
}


export function stretchBox(box: Box, pixels: number) {
    box.x -= pixels
    box.y -= pixels
    box.w += 2 * pixels
    box.h += 2 * pixels
}
